module.exports = require('./GenericStore')